<div class="typeahead-search-wrapper">
  <img
    class="search-icon"
    [src]="isFocused ? 'assets/icons/dark/Search.svg' : 'assets/icons/grey/Search.svg'"
    alt=""
    aria-hidden="true" />
  <input
    #typeaheadInput="ngbTypeahead"
    type="text"
    class="typeahead-search-input"
    [class.form-error-border]="error"
    [attr.aria-invalid]="error ? true : null"
    [attr.id]="controlId"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngbTypeahead]="search"
    [inputFormatter]="inputFormatter"
    [resultTemplate]="activeResultTemplate"
    [popperOptions]="popperOptions"
    [editable]="editable"
    [focusFirst]="true"
    container="body"
    [popupClass]="'typeahead-search-dropdown'"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (selectItem)="selectItem.emit($event)" />
</div>

<ng-template #defaultResultTemplate let-r="result">{{ resultFormatter ? resultFormatter(r) : r }}</ng-template>
